export class ImportFileParseError {

  public lineNumber: number;
  public columnNumber: number;
  public fieldName: string;
  public fieldValue: string;
  public message: string;

  static fromDto(data: any): ImportFileParseError {
    if (!data) {
      return null;
    }

    const parseError = new ImportFileParseError();

    parseError.lineNumber   = data.line_number;
    parseError.columnNumber = data.column_number;
    parseError.fieldName    = data.field_name;
    parseError.fieldValue   = data.field_value;
    parseError.message      = data.message;

    return parseError;
  }
}
